<template lang="pug">
  .return Return page
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
